import { D as DEFAULT_LANG, a as DEFAULT_TYPE_ID, S as STARS_COUNT, E as EMOJI_POS_VALUE, b as EMOJI_NEG_VALUE, F as FIRM_SOURCE, R as RULES_LINKS_FIRM, c as RULES_LINKS_NOFIRM } from './const.js';

class HTTPError extends Error {
    constructor(status, message) {
        super(message);
        this.message = message;
        this.name = 'HTTPError';
        this.status = status;
    }
}
class FastRPCError extends Error {
    constructor(status, message, data) {
        super(message);
        this.status = status;
        this.name = 'FastRPCError';
        this.message = message;
        if (data) {
            this.data = data;
        }
    }
}
class TimeoutError extends Error {
    constructor() {
        const message = 'Request timed out';
        super(message);
        this.name = 'TimeoutError';
        this.message = message;
    }
}
class AbortError extends Error {
    constructor() {
        const message = 'Request aborted';
        super(message);
        this.name = 'AbortError';
        this.message = message;
    }
}

/* eslint-disable */
/* eslint-disable no-magic-numbers */
/*
FastRPC library written in TypeScript
Copyright (C) 2005-2019 Seznam.cz, a.s.

This library is free software; you can redistribute it and/or
modify it under the terms of the GNU Lesser General Public
License as published by the Free Software Foundation; either
version 2.1 of the License, or (at your option) any later version.

This library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public
License along with this library; if not, write to the Free Software
Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA

Seznam.cz, a.s.
Radlická 3294/10, Praha 5, 15000, Czech Republic
http://www.seznam.cz, mailto:fastrpc@firma.seznam.cz
*/
const TYPE_CALL = 13;
const TYPE_RESPONSE = 14;
const TYPE_FAULT = 15;
const TYPE_INT = 1;
const TYPE_BOOL = 2;
const TYPE_DOUBLE = 3;
const TYPE_STRING = 4;
const TYPE_DATETIME = 5;
const TYPE_BINARY = 6;
const TYPE_INT8P = 7;
const TYPE_INT8N = 8;
const TYPE_STRUCT = 10;
const TYPE_ARRAY = 11;
const TYPE_NULL = 12;
let _hints = null;
let _path = [];
let _data;
let _pointer = 0;
function _getByte() {
    if ((_pointer + 1) > _data.length) {
        throw new Error('Cannot read byte from buffer');
    }
    return _data[_pointer++];
}
/**
 * In little endian
 */
function _getInt(bytes) {
    let result = 0;
    let factor = 1;
    for (let i = 0; i < bytes; i++) {
        result += factor * _getByte();
        factor *= 256;
    }
    return result;
}
function _decodeUTF8(length) {
    /* pouzite optimalizace:
     * - pracujeme nad stringem namisto pole; FF i IE to kupodivu (!) maji rychlejsi
     * - while namisto for
     * - cachovani fromCharcode, _data i _pointer
     * - vyhozeni _getByte
     */
    let remain = length;
    let result = "";
    if (!length) {
        return result;
    }
    let c = 0, c1 = 0, c2 = 0, c3 = 0;
    let SfCC = String.fromCharCode;
    let data = _data;
    let pointer = _pointer;
    while (1) {
        remain--;
        c = data[pointer];
        pointer += 1; /* FIXME safari bug */
        if (c < 128) {
            result += SfCC(c);
        }
        else if ((c > 191) && (c < 224)) {
            c1 = data[pointer] & 63;
            pointer += 1; /* FIXME safari bug */
            result += SfCC(((c & 31) << 6) | c1);
            remain -= 1;
        }
        else if (c < 240) {
            c1 = data[pointer++] & 63;
            c2 = data[pointer++] & 63;
            let cp = ((c & 15) << 12) | (c1 << 6) | c2;
            result += SfCC(cp);
            remain -= 2;
        }
        else if (c < 248) { /* 4 byte stuff */
            c1 = data[pointer++] & 63;
            c2 = data[pointer++] & 63;
            c3 = data[pointer++] & 63;
            let cp = ((c & 0x07) << 0x12) | (c1 << 0x0C) | (c2 << 0x06) | c3;
            if (cp > 0xFFFF) { /* surrogates */
                cp -= 0x10000;
                result += SfCC((cp >>> 10) & 0x3FF | 0xD800);
                cp = cp & 0x3FF | 0xDC00;
            }
            result += SfCC(cp);
            remain -= 3;
        }
        else if (c < 252) { /* 5 byte stuff, throw away */
            pointer += 4;
            remain -= 4;
        }
        else { /* 6 byte stuff, throw away */
            pointer += 5;
            remain -= 5;
        }
        /* pokud bylo na vstupu nevalidni UTF-8, mohli jsme podlezt... */
        if (remain <= 0) {
            break;
        }
    }
    /* normalne je v tuto chvili remain = 0; pokud byla ale na vstupu chyba, mohlo klesnout pod nulu. vratime pointer na spravny konec stringu */
    _pointer = pointer + remain;
    return result;
}
function _encodeUTF8(str) {
    let result = [];
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c >= 55296 && c <= 56319) { /* surrogates */
            let c2 = str.charCodeAt(++i);
            c = ((c & 0x3FF) << 10) + (c2 & 0x3FF) + 0x10000;
        }
        if (c < 128) {
            result.push(c);
        }
        else if (c < 2048) {
            result.push((c >> 6) | 192);
            result.push((c & 63) | 128);
        }
        else if (c < 65536) {
            result.push((c >> 12) | 224);
            result.push(((c >> 6) & 63) | 128);
            result.push((c & 63) | 128);
        }
        else {
            result.push((c >> 18) | 240);
            result.push(((c >> 12) & 63) | 128);
            result.push(((c >> 6) & 63) | 128);
            result.push((c & 63) | 128);
        }
    }
    return result;
}
function _getDouble() {
    let bytes = [];
    let index = 8;
    while (index--) {
        bytes[index] = _getByte();
    }
    let sign = (bytes[0] & 0x80 ? 1 : 0);
    let exponent = (bytes[0] & 127) << 4;
    exponent += bytes[1] >> 4;
    if (exponent === 0) {
        return Math.pow(-1, sign) * 0;
    }
    let mantissa = 0;
    let byteIndex = 1;
    let bitIndex = 3;
    index = 1;
    do {
        let bitValue = (bytes[byteIndex] & (1 << bitIndex) ? 1 : 0);
        mantissa += bitValue * Math.pow(2, -index);
        index++;
        bitIndex--;
        if (bitIndex < 0) {
            bitIndex = 7;
            byteIndex++;
        }
    } while (byteIndex < bytes.length);
    if (exponent == 0x7ff) {
        if (mantissa) {
            return NaN;
        }
        else {
            return Math.pow(-1, sign) * Infinity;
        }
    }
    exponent -= (1 << 10) - 1;
    return Math.pow(-1, sign) * Math.pow(2, exponent) * (1 + mantissa);
}
/**
 * Zakoduje KLADNE cele cislo, little endian
 */
function _encodeInt(data) {
    if (!data) {
        return [0];
    }
    let result = [];
    let remain = data;
    while (remain) {
        let value = remain % 256;
        remain = (remain - value) / 256;
        result.push(value);
    }
    return result;
}
/**
 * Zakoduje IEEE-754 double
 */
function _encodeDouble(num) {
    let result = [];
    let expBits = 11;
    let fracBits = 52;
    let bias = (1 << (expBits - 1)) - 1;
    let sign = 0;
    let exponent = 0;
    let fraction = 0;
    if (isNaN(num)) {
        exponent = (1 << expBits) - 1;
        fraction = 1;
        sign = 0;
    }
    else if (num === Infinity || num === -Infinity) {
        exponent = (1 << expBits) - 1;
        fraction = 0;
        sign = num < 0 ? 1 : 0;
    }
    else if (num === 0) {
        exponent = 0;
        fraction = 0;
        sign = 1 / num === -Infinity ? 1 : 0;
    }
    else { /* normal number */
        sign = num < 0 ? 1 : 0;
        let abs = Math.abs(num);
        if (abs >= Math.pow(2, 1 - bias)) {
            let ln = Math.min(Math.floor(Math.log(abs) / Math.LN2), bias);
            exponent = ln + bias;
            fraction = abs * Math.pow(2, fracBits - ln) - Math.pow(2, fracBits);
        }
        else {
            exponent = 0;
            fraction = abs / Math.pow(2, 1 - bias - fracBits);
        }
    }
    let bits = [];
    for (let i = fracBits; i > 0; i--) {
        bits.push(fraction % 2 ? 1 : 0);
        fraction = Math.floor(fraction / 2);
    }
    for (let i = expBits; i > 0; i--) {
        bits.push(exponent % 2 ? 1 : 0);
        exponent = Math.floor(exponent / 2);
    }
    bits.push(sign ? 1 : 0);
    num = 0;
    let index = 0;
    while (bits.length) {
        num += (1 << index) * bits.shift();
        index++;
        if (index == 8) {
            result.push(num);
            num = 0;
            index = 0;
        }
    }
    return result;
}
function _parseValue() {
    /* pouzite optimalizace:
     * - zkracena cesta ke konstantam v ramci redukce tecek
     * - posun nejpouzivanejsich typu nahoru
     */
    let first = _getInt(1);
    let type = first >> 3;
    let length, lengthBytes, result, members;
    switch (type) {
        case TYPE_STRING:
            lengthBytes = (first & 7) + 1;
            length = _getInt(lengthBytes);
            return _decodeUTF8(length);
        case TYPE_STRUCT:
            result = {};
            lengthBytes = (first & 7) + 1;
            members = _getInt(lengthBytes);
            while (members--) {
                _parseMember(result);
            }
            return result;
        case TYPE_ARRAY:
            result = [];
            lengthBytes = (first & 7) + 1;
            members = _getInt(lengthBytes);
            while (members--) {
                result.push(_parseValue());
            }
            return result;
        case TYPE_BOOL:
            return (first & 1 ? true : false);
        case TYPE_INT:
            length = first & 7;
            let max = Math.pow(2, 8 * length);
            result = _getInt(length);
            if (result >= max / 2) {
                result -= max;
            }
            return result;
        case TYPE_DATETIME:
            _getByte();
            let ts = _getInt(4);
            for (let i = 0; i < 5; i++) {
                _getByte();
            }
            return new Date(1000 * ts);
        case TYPE_DOUBLE:
            return _getDouble();
        case TYPE_BINARY:
            lengthBytes = (first & 7) + 1;
            length = _getInt(lengthBytes);
            result = [];
            while (length--) {
                result.push(_getByte());
            }
            return result;
        case TYPE_INT8P:
            length = (first & 7) + 1;
            return _getInt(length);
        case TYPE_INT8N:
            length = (first & 7) + 1;
            return -_getInt(length);
        case TYPE_NULL:
            return null;
        default:
            throw new Error(`Unknown type ${type}`);
    }
}
function _append(arr1, arr2) {
    let len = arr2.length;
    for (let i = 0; i < len; i++) {
        arr1.push(arr2[i]);
    }
}
function _parseMember(result) {
    const nameLength = _getInt(1);
    const name = _decodeUTF8(nameLength);
    result[name] = _parseValue();
}
function _serializeValue(result, value) {
    if (value === null) {
        result.push(TYPE_NULL << 3);
        return;
    }
    switch (typeof (value)) {
        case 'string':
            let strData = _encodeUTF8(value);
            let intData = _encodeInt(strData.length);
            let first = TYPE_STRING << 3;
            first += (intData.length - 1);
            result.push(first);
            _append(result, intData);
            _append(result, strData);
            break;
        case 'number':
            if (_getHint() === 'float') { /* float */
                let first = TYPE_DOUBLE << 3;
                let floatData = _encodeDouble(value);
                result.push(first);
                _append(result, floatData);
            }
            else { /* int */
                let first = (value >= 0 ? TYPE_INT8P : TYPE_INT8N);
                first = first << 3;
                let data = _encodeInt(Math.abs(value));
                first += (data.length - 1);
                result.push(first);
                _append(result, data);
            }
            break;
        case 'boolean':
            let data = TYPE_BOOL << 3;
            if (value) {
                data += 1;
            }
            result.push(data);
            break;
        case 'object':
            if (value instanceof Date) {
                _serializeDate(result, value);
            }
            else if (value instanceof Array) {
                _serializeArray(result, value);
            }
            else {
                _serializeStruct(result, value);
            }
            break;
        default: /* undefined, function, ... */
            throw new Error(`FRPC does not allow value ${value}`);
    }
}
function _serializeArray(result, data) {
    if (_getHint() === 'binary') { /* binarni data */
        let first = TYPE_BINARY << 3;
        let intData = _encodeInt(data.length);
        first += (intData.length - 1);
        result.push(first);
        _append(result, intData);
        _append(result, data);
        return;
    }
    let first = TYPE_ARRAY << 3;
    let intData = _encodeInt(data.length);
    first += (intData.length - 1);
    result.push(first);
    _append(result, intData);
    for (let i = 0; i < data.length; i++) {
        _path.push(i.toString());
        _serializeValue(result, data[i]);
        _path.pop();
    }
}
function _serializeStruct(result, data) {
    let numMembers = 0;
    let p;
    for (p in data) {
        numMembers++;
    }
    let first = TYPE_STRUCT << 3;
    let intData = _encodeInt(numMembers);
    first += (intData.length - 1);
    result.push(first);
    _append(result, intData);
    for (let p in data) {
        let strData = _encodeUTF8(p);
        result.push(strData.length);
        _append(result, strData);
        _path.push(p);
        _serializeValue(result, data[p]);
        _path.pop();
    }
}
function _serializeDate(result, date) {
    result.push(TYPE_DATETIME << 3);
    /* 1 bajt, zona */
    let zone = date.getTimezoneOffset() / 15; /* pocet ctvrthodin */
    if (zone < 0) {
        zone += 256;
    } /* dvojkovy doplnek */
    result.push(zone);
    /* 4 bajty, timestamp */
    let ts = Math.round(date.getTime() / 1000);
    if (ts < 0 || ts >= Math.pow(2, 31)) {
        ts = -1;
    }
    if (ts < 0) {
        ts += Math.pow(2, 32);
    } /* dvojkovy doplnek */
    let tsData = _encodeInt(ts);
    while (tsData.length < 4) {
        tsData.push(0);
    } /* do 4 bajtu */
    _append(result, tsData);
    /* 5 bajtu, zbyle haluze */
    let year = date.getFullYear() - 1600;
    year = Math.max(year, 0);
    year = Math.min(year, 2047);
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let dow = date.getDay();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    result.push((seconds & 0x1f) << 3 | (dow & 0x07));
    result.push(((minutes & 0x3f) << 1) | ((seconds & 0x20) >> 5) | ((hours & 0x01) << 7));
    result.push(((hours & 0x1e) >> 1) | ((day & 0x0f) << 4));
    result.push(((day & 0x1f) >> 4) | ((month & 0x0f) << 1) | ((year & 0x07) << 5));
    result.push((year & 0x07f8) >> 3);
}
/**
 * Vrati aktualni hint, na zaklade "_path" a "_hints"
 */
function _getHint() {
    if (!_hints) {
        return null;
    }
    if (typeof (_hints) !== 'object') {
        return _hints;
    } /* skalarni varianta */
    return _hints && _hints[_path.join('.')];
}
function serialize(data, hints) {
    let result = [];
    _path = [];
    _hints = hints;
    _serializeValue(result, data);
    _hints = null;
    return result;
}
/**
 * pokud string, pak typ (skalarni) hodnoty "data". Pokud objekt,
 * pak mnozina dvojic "cesta":"datovy typ"; cesta je teckami dodelena posloupnost
 * klicu a/nebo indexu v datech. Typ je "float" nebo "binary".
 */
function serializeCall(method, data, hints) {
    let result = serialize(data, hints);
    /* utrhnout hlavicku pole (dva bajty) */
    result.shift();
    result.shift();
    let encodedMethod = _encodeUTF8(method);
    result.unshift.apply(result, encodedMethod);
    result.unshift(encodedMethod.length);
    result.unshift(TYPE_CALL << 3);
    result.unshift(0xCA, 0x11, 0x02, 0x01);
    return result;
}
function parse(data) {
    _pointer = 0;
    _data = data;
    const magic1 = _getByte();
    const magic2 = _getByte();
    if (magic1 !== 0xCA || magic2 !== 0x11) {
        _data = new Uint8Array();
        throw new Error(`Missing FRPC magic`);
    }
    /* zahodit zbytek hlavicky */
    _getByte();
    _getByte();
    let first = _getInt(1);
    let type = first >> 3;
    if (type === TYPE_FAULT) {
        const num = _parseValue();
        const msg = _parseValue();
        _data = new Uint8Array();
        throw new Error(`FRPC/${num}: ${msg}`);
    }
    let result;
    switch (type) {
        case TYPE_RESPONSE:
            result = _parseValue();
            if (_pointer < _data.length) {
                _data = new Uint8Array();
                throw new Error(`Garbage after FRPC data`);
            }
            break;
        case TYPE_CALL:
            const nameLength = _getInt(1);
            let name = _decodeUTF8(nameLength);
            let params = [];
            while (_pointer < _data.length) {
                params.push(_parseValue());
            }
            _data = new Uint8Array();
            return { method: name, params: params };
        default:
            _data = new Uint8Array();
            throw new Error(`Unsupported TYPE ${type}`);
    }
    _data = new Uint8Array();
    return result;
}

const OPTIONS = {
    timeout: 0,
    hints: {},
    url: '/RPC2',
    headers: [],
    type: 'frpc',
};
const STATUS_OK = 200;
const STATUS_ERROR = 400;
const STATUS_REDIRECT = 300;
const NO_FUNC = function () { };
class Request {
    constructor(method, args = [], options = {}) {
        this._resolve = NO_FUNC;
        this._reject = NO_FUNC;
        this._options = Object.assign(Object.assign({}, OPTIONS), options);
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('abort', this);
        xhr.addEventListener('error', this);
        xhr.addEventListener('timeout', this);
        xhr.addEventListener('load', this);
        xhr.open('POST', this._options.url, true);
        if ('timeout' in xhr && typeof xhr.timeout !== 'function') {
            // v IE lze az po .open()
            xhr.timeout = this._options.timeout;
        }
        if (options.withCredentials) {
            xhr.withCredentials = true;
        }
        for (let index = 0; index < this._options.headers.length; index++) {
            const { name, value } = this._options.headers[index];
            xhr.setRequestHeader(name, value);
        }
        if (this._options.type === 'frpc' && Uint8Array) {
            xhr.responseType = 'arraybuffer';
            xhr.setRequestHeader('Accept', 'application/x-frpc');
            xhr.setRequestHeader('Content-Type', 'application/x-frpc');
            xhr.send(new Uint8Array(serializeCall(method, args, options.hints)));
        }
        else {
            throw new Error('Unknown RPC type, frpc only supported or no Uint8Array!');
        }
        this._xhr = xhr;
    }
    getPromise() {
        return this._promise;
    }
    abort() {
        if (this._xhr) {
            this._xhr.abort();
            this._reject(new AbortError());
        }
    }
    handleEvent(event) {
        let error = null;
        switch (event.type) {
            case 'abort':
                this._reject(new AbortError());
                break;
            case 'error':
                error = new HTTPError(this._xhr.status, this._xhr.statusText);
                this._reject(error);
                break;
            case 'timeout':
                error = new TimeoutError();
                this._reject(error);
                break;
            case 'load':
                this._response(this._xhr);
                break;
            // nic
        }
    }
    _response(xhr) {
        const status = xhr.status;
        if (status < STATUS_OK || status >= STATUS_REDIRECT) {
            this._reject(new HTTPError(status, xhr.statusText));
            return;
        }
        let data = null;
        if (this._options.type === 'frpc') {
            if (Uint8Array && xhr.response instanceof ArrayBuffer) {
                data = parse(new Uint8Array(xhr.response));
            }
        }
        if (!data) {
            this._reject(new FastRPCError(STATUS_ERROR, 'Cannot parse response, or no respone'));
        }
        if ('status' in data && (data.status < STATUS_OK || data.status >= STATUS_REDIRECT)) {
            this._reject(new FastRPCError(data.status, data.statusMessage, data.data));
            return;
        }
        this._resolve(data);
    }
}

function call(method, args = [], options = {}) {
    return new Request(method, args, options).getPromise();
}

const a = (n) => n == 1 ? 'one' : 'other';
const d = (n) => {
  const s = String(n).split('.'), v0 = !s[1];
  return n == 1 && v0 ? 'one' : 'other';
};
const cs = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1];
  return n == 1 && v0 ? 'one'
    : (i >= 2 && i <= 4) && v0 ? 'few'
    : !v0 ? 'many'
    : 'other';
};
const da = (n) => {
  const s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
};
const de = d;
const en = d;
const es = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  return n == 1 ? 'one'
    : i != 0 && i1000000 == 0 && v0 ? 'many'
    : 'other';
};
const fr = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  return n >= 0 && n < 2 ? 'one'
    : i != 0 && i1000000 == 0 && v0 ? 'many'
    : 'other';
};
const hu = a;
const it = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  return n == 1 && v0 ? 'one'
    : i != 0 && i1000000 == 0 && v0 ? 'many'
    : 'other';
};
const nl = d;
const pl = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  return n == 1 && v0 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? 'few'
    : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 12 && i100 <= 14) ? 'many'
    : 'other';
};
const ru = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  return v0 && i10 == 1 && i100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? 'few'
    : v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 11 && i100 <= 14) ? 'many'
    : 'other';
};
const sk = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1];
  return n == 1 && v0 ? 'one'
    : (i >= 2 && i <= 4) && v0 ? 'few'
    : !v0 ? 'many'
    : 'other';
};
const sl = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
  return v0 && i100 == 1 ? 'one'
    : v0 && i100 == 2 ? 'two'
    : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few'
    : 'other';
};
const tr = a;
const uk = (n) => {
  const s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  return v0 && i10 == 1 && i100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? 'few'
    : v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 11 && i100 <= 14) ? 'many'
    : 'other';
};

/**
 * A set of utility functions that are called by the compiled Javascript
 * functions, these are included locally in the output of {@link MessageFormat.compile compile()}.
 */
/**
 * Utility function for `{N, plural|selectordinal, ...}`
 *
 * @param value The key to use to find a pluralization rule
 * @param offset An offset to apply to `value`
 * @param lcfunc A locale function from `pluralFuncs`
 * @param data The object from which results are looked up
 * @param isOrdinal If true, use ordinal rather than cardinal rules
 * @returns The result of the pluralization
 */
function plural(value, offset, lcfunc, data, isOrdinal) {
    if ({}.hasOwnProperty.call(data, value))
        return data[value];
    if (offset)
        value -= offset;
    var key = lcfunc(value, isOrdinal);
    return key in data ? data[key] : data.other;
}

const DialogLocales = {
    bg: {
        commentLicence: (d) => "С добавянето на оценка вие се съгласявате с " + d.linkAgrStart + "условията" + d.linkAgrEnd + " и " + d.linkRulStart + "правилата" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "С даването на оценка се съгласявате с " + d.linkRulStart + "правилата" + d.linkRulEnd + " и " + d.linkPerStart + "политиката за обработка на лични данни" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "С изпращането на снимки вие се съгласявате с " + d.linkAgrStart + "лицензионните условия" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Със запазването на оценката се съгласявате с " + d.linkAgrStart + "условията" + d.linkAgrEnd + " и " + d.linkRulStart + "правилата" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Оценявате като " + d.user,
        verifiedUserTitle: () => "Потвърден потребител",
        verifiedUserText: () => "Този акаунт е потвърден от Seznam и представлява реално лице, регистрирана фирма или организация. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Повече за потвърдените акаунти</a>",
        tooltipMoreChoices: () => "Повече за отделните възможности",
        "continue": () => "Продължи",
        motivateToComment: () => "Благодарим ви. Добавете коментар, за да улесните избора на другите.",
        textPlaceholder: () => "Тук е мястото за вашето мнение",
        textPlaceholderFirm: () => "Добавете текстова оценка, за да помогнете на другите да се ориентират по-добре.",
        uploadPhoto: () => "Добави снимка",
        addNothing: () => "Няма какво повече да добавя",
        addReview: () => "Добави оценка",
        add: () => "Добави",
        deleteComment: () => "Искате ли да изтриете оценката?",
        "delete": () => "Изтрий",
        cancel: () => "Отказ",
        putReviewError: () => "За съжаление не успяхме да запишем оценката. Моля, опитайте отново.",
        removeReviewError: () => "За съжаление не успяхме да изтрием оценката.",
        tryAgain: () => "Опитайте отново",
        thankYouResponse: () => "Благодарим за оценката",
        numOfChar: (d) => "Остават <b>" + d.chars + "</b> " + plural(d.chars, 0, cs, { one: "знак", few: "знака", other: "знаци" }),
        alternativesTitle: () => "На това място можете да оцените",
        uploadPhotoErrorCommon: () => "За съжаление снимките не можаха да бъдат добавени. Моля, опитайте отново.",
        uploadPhotoErrorExtension: () => "Избрали сте неподдържан тип файл, добавете само .jpg или .png.",
        uploadPhotoErrorSize: () => "Някои снимки са твърде малки, минималните размери са 800x600px.",
        uploadPhotoErrorMaxCount: () => "Някои снимки не бяха добавени, можете да добавите максимум 20 снимки.",
        afterDelete: () => "Оценката беше изтрита",
        save: () => "Запази",
        editFrom: (d) => "Редактирате своята оценка от " + d.date,
        imageDuplicateError: () => "Снимката е качена дублирано.",
        cancelChanges: () => "Искате ли да отмените промените?",
        throwAway: () => "Отмени",
        back: () => "Назад",
        questionsTitle: (d) => "Благодарим за оценката." + d.br + "Бихте ли ни помогнали с още няколко въпроса?",
        questionsPosition: (d) => "Въпрос " + d.current + " / " + d.total,
        questionsThankYou: () => "Благодарим за вашата помощ",
        questionsPrev: () => "Предишен въпрос:",
        responseYes: () => "Да",
        responseNo: () => "Не",
        responseDontKnow: () => "Не знам"
    },
    cs: {
        commentLicence: (d) => "Přidáním hodnocení souhlasíte s " + d.linkAgrStart + "podmínkami" + d.linkAgrEnd + " a " + d.linkRulStart + "pravidly" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Hodnocením souhlasíte s " + d.linkRulStart + "pravidly" + d.linkRulEnd + " a " + d.linkPerStart + "zásadami zpracování osobních údajů" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Odesláním fotek souhlasíte s " + d.linkAgrStart + "licenčními podmínkami" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Uložením hodnocení souhlasíte s " + d.linkAgrStart + "podmínkami" + d.linkAgrEnd + " a " + d.linkRulStart + "pravidly" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Hodnotíte jako " + d.user,
        verifiedUserTitle: () => "Ověřený uživatel",
        verifiedUserText: () => "Tento účet je ověřený Seznamem a představuje skutečnou osobu, zaregistrovanou firmu nebo subjekt. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Více o ověřených účtech</a>",
        tooltipMoreChoices: () => "Více o jednotlivých možnostech",
        "continue": () => "Pokračovat",
        motivateToComment: () => "Děkujeme. Připojte komentář, usnadníte výběr ostatním.",
        textPlaceholder: () => "Tady je místo pro váš názor",
        textPlaceholderFirm: () => "Vložte ještě textové hodnocení a pomůžete se lépe zorientovat ostatním.",
        uploadPhoto: () => "Přidat fotku",
        addNothing: () => "Již nechci nic dodat",
        addReview: () => "Přidat hodnocení",
        add: () => "Přidat",
        deleteComment: () => "Chcete hodnocení smazat?",
        "delete": () => "Smazat",
        cancel: () => "Zrušit",
        putReviewError: () => "Hodnocení se bohužel nepodařilo uložit. Zkuste to prosím znovu.",
        removeReviewError: () => "Hodnocení se bohužel nepodařilo smazat.",
        tryAgain: () => "Zkusit znovu",
        thankYouResponse: () => "Děkujeme za hodnocení",
        numOfChar: (d) => "Zbývá <b>" + d.chars + "</b> " + plural(d.chars, 0, cs, { one: "znak", few: "znaky", other: "znaků" }),
        alternativesTitle: () => "Na tomto místě můžete ohodnotit",
        uploadPhotoErrorCommon: () => "Fotky se bohužel nepodařilo přidat. Zkuste to prosím znovu.",
        uploadPhotoErrorExtension: () => "Vybrali jste nepodporovaný typ souboru, přidejte jen .jpg nebo .png.",
        uploadPhotoErrorSize: () => "Některé fotky jsou příliš malé, minimální rozměry jsou 800x600px.",
        uploadPhotoErrorMaxCount: () => "Některé fotky se nepřidaly, je možné přidat pouze 20 fotek.",
        afterDelete: () => "Hodnocení jsme smazali",
        save: () => "Uložit",
        editFrom: (d) => "Upravujete své hodnocení z " + d.date,
        imageDuplicateError: () => "Fotografie nahrána duplicitně.",
        cancelChanges: () => "Chcete změny zahodit?",
        throwAway: () => "Zahodit",
        back: () => "Zpět",
        questionsTitle: (d) => "Děkujeme za hodnocení." + d.br + "Pomůžete nám ještě s pár otázkami?",
        questionsPosition: (d) => "Otázka " + d.current + " / " + d.total,
        questionsThankYou: () => "Děkujeme za vaši pomoc",
        questionsPrev: () => "Předchozí otázka:",
        responseYes: () => "Ano",
        responseNo: () => "Ne",
        responseDontKnow: () => "Nevím"
    },
    da: {
        commentLicence: (d) => "Ved at tilføje en bedømmelse accepterer du " + d.linkAgrStart + "betingelserne" + d.linkAgrEnd + " og " + d.linkRulStart + "reglerne" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Ved at afgive en bedømmelse accepterer du " + d.linkRulStart + "reglerne" + d.linkRulEnd + " og " + d.linkPerStart + "retningslinjerne for behandling af personoplysninger" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Ved at indsende billeder accepterer du " + d.linkAgrStart + "licensbetingelserne" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Ved at gemme bedømmelsen accepterer du " + d.linkAgrStart + "betingelserne" + d.linkAgrEnd + " og " + d.linkRulStart + "reglerne" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Du bedømmer som " + d.user,
        verifiedUserTitle: () => "Verificeret bruger",
        verifiedUserText: () => "Denne konto er verificeret af Seznam og repræsenterer en reel person, en registreret virksomhed eller en organisation. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Mere om verificerede konti</a>",
        tooltipMoreChoices: () => "Mere om de enkelte muligheder",
        "continue": () => "Fortsæt",
        motivateToComment: () => "Tak. Tilføj en kommentar og gør det nemmere for andre at vælge.",
        textPlaceholder: () => "Her er plads til din mening",
        textPlaceholderFirm: () => "Tilføj en tekstbedømmelse for at hjælpe andre med bedre at finde rundt.",
        uploadPhoto: () => "Tilføj et foto",
        addNothing: () => "Jeg vil ikke tilføje mere",
        addReview: () => "Tilføj bedømmelse",
        add: () => "Tilføj",
        deleteComment: () => "Vil du slette bedømmelsen?",
        "delete": () => "Slet",
        cancel: () => "Annuller",
        putReviewError: () => "Desværre kunne bedømmelsen ikke gemmes. Prøv venligst igen.",
        removeReviewError: () => "Desværre kunne bedømmelsen ikke slettes.",
        tryAgain: () => "Prøv igen",
        thankYouResponse: () => "Tak for din bedømmelse",
        numOfChar: (d) => "Der er <b>" + d.chars + "</b> " + plural(d.chars, 0, da, { one: "tegn", other: "tegn" }) + " tilbage",
        alternativesTitle: () => "På dette sted kan du bedømme",
        uploadPhotoErrorCommon: () => "Desværre kunne billederne ikke tilføjes. Prøv venligst igen.",
        uploadPhotoErrorExtension: () => "Du har valgt en ikke-understøttet filtype. Tilføj kun .jpg eller .png.",
        uploadPhotoErrorSize: () => "Nogle billeder er for små, minimumsstørrelsen er 800x600px.",
        uploadPhotoErrorMaxCount: () => "Nogle billeder blev ikke tilføjet, du kan kun tilføje op til 20 billeder.",
        afterDelete: () => "Bedømmelsen er blevet slettet",
        save: () => "Gem",
        editFrom: (d) => "Du redigerer din bedømmelse fra " + d.date,
        imageDuplicateError: () => "Billedet blev uploadet to gange.",
        cancelChanges: () => "Vil du kassere ændringerne?",
        throwAway: () => "Kassér",
        back: () => "Tilbage",
        questionsTitle: (d) => "Tak for din bedømmelse." + d.br + "Vil du hjælpe os med et par spørgsmål?",
        questionsPosition: (d) => "Spørgsmål " + d.current + " / " + d.total,
        questionsThankYou: () => "Tak for din hjælp",
        questionsPrev: () => "Forrige spørgsmål:",
        responseYes: () => "Ja",
        responseNo: () => "Nej",
        responseDontKnow: () => "Ved ikke"
    },
    de: {
        commentLicence: (d) => "Indem Sie eine Bewertung hinzufügen, akzeptieren Sie unsere " + d.linkAgrStart + "Bedingungen" + d.linkAgrEnd + " und " + d.linkRulStart + "Regeln" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Mit der Bewertung stimmen Sie den " + d.linkRulStart + "Regeln" + d.linkRulEnd + " und den " + d.linkPerStart + "Datenschutzrichtlinien" + d.linkPerEnd + " zu.",
        picturesLinkFirm: (d) => "Durch die Einreichung von Fotos stimmen Sie den " + d.linkAgrStart + "Lizenzbedingungen" + d.linkAgrEnd + " zu.",
        acceptLicence: (d) => "Mit dem Speichern der Bewertung stimmen Sie den " + d.linkAgrStart + "Bedingungen" + d.linkAgrEnd + " und den " + d.linkRulStart + "Regeln" + d.linkRulEnd + " zu.",
        reviewAsUser: (d) => "Sie bewerten als " + d.user,
        verifiedUserTitle: () => "Verifizierter Benutzer",
        verifiedUserText: () => "Dieses Konto wurde von Seznam verifiziert und stellt eine reale Person, ein eingetragenes Unternehmen oder eine Einrichtung dar. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Mehr zu verifizierten Konten</a>",
        tooltipMoreChoices: () => "Mehr über die einzelnen Optionen",
        "continue": () => "Fortsetzen",
        motivateToComment: () => "Danke. Fügen Sie einen Kommentar hinzu, um anderen die Auswahl zu erleichtern.",
        textPlaceholder: () => "Hier können Sie Ihre Meinung teilen",
        textPlaceholderFirm: () => "Bitte fügen Sie eine kurze Bewertung hinzu, um anderen zu helfen.",
        uploadPhoto: () => "Foto hinzufügen",
        addNothing: () => "Ich möchte nichts weiter hinzufügen",
        addReview: () => "Rezension hinzufügen",
        add: () => "Hinzufügen",
        deleteComment: () => "Möchten Sie die Rezension löschen?",
        "delete": () => "Entfernen",
        cancel: () => "Abbrechen",
        putReviewError: () => "Die Bewertung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
        removeReviewError: () => "Leider ist es nicht gelungen, die Bewertung zu löschen.",
        tryAgain: () => "Wiederholen",
        thankYouResponse: () => "Danke für Ihre Rezension",
        numOfChar: (d) => "<b>" + d.chars + "</b> " + plural(d.chars, 0, de, { one: "Zeichen", other: "Zeichen" }) + " übrig",
        alternativesTitle: () => "Hier können Sie eine Bewertung hinzufügen",
        uploadPhotoErrorCommon: () => "Leider konnten die Fotos nicht hinzugefügt werden. Bitte versuchen Sie es erneut.",
        uploadPhotoErrorExtension: () => "Sie haben einen nicht unterstützten Dateityp ausgewählt, bitte fügen Sie nur .jpg, .png oder .heic hinzu.",
        uploadPhotoErrorSize: () => "Einige Fotos sind zu klein, die Mindestabmessungen betragen 800x600 Pixel.",
        uploadPhotoErrorMaxCount: () => "Einige Fotos wurden nicht hinzugefügt, es können nur 20 Fotos hinzugefügt werden.",
        afterDelete: () => "Die Rezension wurde gelöscht",
        save: () => "Speichern",
        editFrom: (d) => "Sie bearbeiten Ihre Bewertung vom " + d.date,
        imageDuplicateError: () => "Dupliziertes Foto hochgeladen.",
        cancelChanges: () => "Änderungen verwerfen?",
        throwAway: () => "Verwerfen",
        back: () => "Zurück",
        questionsTitle: (d) => "Vielen Dank für Ihre Bewertung." + d.br + "Könnten Sie uns noch mit ein paar Fragen helfen?",
        questionsPosition: (d) => "Frage " + d.current + " / " + d.total,
        questionsThankYou: () => "Vielen Dank für Ihre Hilfe",
        questionsPrev: () => "Vorherige Frage:",
        responseYes: () => "Ja",
        responseNo: () => "Nein",
        responseDontKnow: () => "Weiß nicht"
    },
    en: {
        commentLicence: (d) => "By adding a review you are agreeing to the " + d.linkAgrStart + "terms" + d.linkAgrEnd + " and " + d.linkRulStart + "conditions" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "By submitting a rating, you agree to the " + d.linkRulStart + "rules" + d.linkRulEnd + " and the " + d.linkPerStart + "personal data processing policy" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "By submitting the photos, you agree to the " + d.linkAgrStart + "terms of license" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "By contributing you agree to the " + d.linkAgrStart + "terms" + d.linkAgrEnd + " and " + d.linkRulStart + "conditions" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "You are reviewing as " + d.user,
        verifiedUserTitle: () => "Verified user",
        verifiedUserText: () => "This account is verified by Seznam and represents a real person, registered company, or other entity. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">More on verified accounts</a>",
        tooltipMoreChoices: () => "More about the different options",
        "continue": () => "Continue",
        motivateToComment: () => "Thank you! Add a comment to help others choose.",
        textPlaceholder: () => "Here's a place for your opinion",
        textPlaceholderFirm: () => "Add a written review to help others get a better understanding.",
        uploadPhoto: () => "Add photo",
        addNothing: () => "I have nothing more to add",
        addReview: () => "Add a rating",
        add: () => "Add",
        deleteComment: () => "Delete this review?",
        "delete": () => "Delete",
        cancel: () => "Cancel",
        putReviewError: () => "Unfortunately we couldn't save your review. Please try again.",
        removeReviewError: () => "Unfortunately the review could not be deleted.",
        tryAgain: () => "Try again",
        thankYouResponse: () => "Thank you for your review",
        numOfChar: (d) => "You have <b>" + d.chars + "</b> " + plural(d.chars, 0, en, { one: "character", other: "characters" }) + " remaining",
        alternativesTitle: () => "Review places at this location",
        uploadPhotoErrorCommon: () => "Sorry, couldn't add the photos. Please try again.",
        uploadPhotoErrorExtension: () => "You selected an unsupported file type, add only .jpg, .png, or .heic.",
        uploadPhotoErrorSize: () => "Some photos are too small, minimum dimensions are 800x600px.",
        uploadPhotoErrorMaxCount: () => "Some photos were not added, only 20 photos can be added.",
        afterDelete: () => "Review successfully deleted",
        save: () => "Save",
        editFrom: (d) => "You're updating your review from " + d.date,
        imageDuplicateError: () => "Duplicate photo.",
        cancelChanges: () => "Discard changes?",
        throwAway: () => "Discard",
        back: () => "Go back",
        questionsTitle: (d) => "Thank you for your review." + d.br + "Can you help us with few questions?",
        questionsPosition: (d) => "Question " + d.current + " / " + d.total,
        questionsThankYou: () => "Thank you for your help",
        questionsPrev: () => "Previous question:",
        responseYes: () => "Yes",
        responseNo: () => "No",
        responseDontKnow: () => "Don't know"
    },
    es: {
        commentLicence: (d) => "Al agregar una reseña, acepta los " + d.linkAgrStart + "términos" + d.linkAgrEnd + " y las " + d.linkRulStart + "normas" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Al calificar, acepta las " + d.linkRulStart + "normas" + d.linkRulEnd + " y las " + d.linkPerStart + "políticas de privacidad" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Al enviar fotos, acepta los " + d.linkAgrStart + "términos de licencia" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Al guardar la reseña, acepta los " + d.linkAgrStart + "términos y condiciones" + d.linkAgrEnd + " y las " + d.linkRulStart + "normas" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Puntúa esto como " + d.user,
        verifiedUserTitle: () => "Usuario autenticado",
        verifiedUserText: () => "Esta cuenta está verificada por la Lista y representa a una persona, empresa registrada o entidad real. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Más información sobre cuentas verificadas</a>",
        tooltipMoreChoices: () => "Más sobre las diferentes opciones",
        "continue": () => "Continuar",
        motivateToComment: () => "Gracias. Añade un comentario, así facilitarás la elección a los demás.",
        textPlaceholder: () => "Aquí puede escribir su opinión",
        textPlaceholderFirm: () => "Agrega también una reseña en texto para ayudar a otros a orientarse mejor.",
        uploadPhoto: () => "Añadir foto",
        addNothing: () => "No quiero añadir nada más",
        addReview: () => "Aňadir evaluación",
        add: () => "Añadir",
        deleteComment: () => "¿Desea eliminar la reseña?",
        "delete": () => "Eliminar",
        cancel: () => "Cancelar",
        putReviewError: () => "Lamentablemente, no se pudo guardar la reseña. Inténtalo de nuevo.",
        removeReviewError: () => "No se pudo eliminar la reseña.",
        tryAgain: () => "Intentar de nuevo",
        thankYouResponse: () => "Gracías de vuestra evaluación",
        numOfChar: (d) => "Libres <b>" + d.chars + "</b> " + plural(d.chars, 0, es, { one: "caracter", other: "caracteres" }),
        alternativesTitle: () => "En este lugar puede dejar una reseña",
        uploadPhotoErrorCommon: () => "No se pudieron añadir las fotos. Inténtalo de nuevo.",
        uploadPhotoErrorExtension: () => "Ha seleccionado un tipo de archivo no compatible; añade solo .jpg o .png.",
        uploadPhotoErrorSize: () => "Algunas fotos son demasiado pequeñas, el tamaño mínimo es de 800x600 px.",
        uploadPhotoErrorMaxCount: () => "Algunas fotos no se añadieron, solo se pueden subir 20 fotos como máximo.",
        afterDelete: () => "Hemos eliminado la reseña",
        save: () => "Salvar",
        editFrom: (d) => "Vds arreglan la evaluación de " + d.date,
        imageDuplicateError: () => "La fotografía fue subida de forma duplicada.",
        cancelChanges: () => "¿Quiere descartar los cambios?",
        throwAway: () => "Descartar",
        back: () => "Volver",
        questionsTitle: (d) => "Gracias por su reseña." + d.br + "¿Nos puede ayudar con algunas preguntas más?",
        questionsPosition: (d) => "Pregunta " + d.current + "/" + d.total,
        questionsThankYou: () => "Gracias por la ayuda",
        questionsPrev: () => "Pregunta anterior:",
        responseYes: () => "Sí",
        responseNo: () => "No",
        responseDontKnow: () => "No sé"
    },
    fi: {},
    fr: {
        commentLicence: (d) => "En ajoutant une évaluation, vous acceptez les " + d.linkAgrStart + "conditions" + d.linkAgrEnd + " et les " + d.linkRulStart + "règles" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "En laissant un avis, vous acceptez les " + d.linkRulStart + "règles" + d.linkRulEnd + " et la " + d.linkPerStart + "politique de traitement des données personnelles" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "En envoyant des photos, vous acceptez les " + d.linkAgrStart + "conditions de licence" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "En enregistrant votre avis, vous acceptez les " + d.linkAgrStart + "conditions" + d.linkAgrEnd + " et les " + d.linkRulStart + "règles" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Vous évaluez actuellement en tant que " + d.user,
        verifiedUserTitle: () => "Utilisateur vérifié",
        verifiedUserText: () => "Ce compte est vérifié par Seznam et représente une personne réelle, une société ou une entité enregistrée. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">En savoir plus sur les comptes vérifiés</a>",
        tooltipMoreChoices: () => "En savoir plus sur les différentes options",
        "continue": () => "Continuer",
        motivateToComment: () => "Merci. Vos commentaires sont utiles aux autres utilisateurs.",
        textPlaceholder: () => "Partager votre avis ici",
        textPlaceholderFirm: () => "Ajoutez un avis sous forme de texte pour aider les autres à mieux s'orienter.",
        uploadPhoto: () => "Ajouter une photo",
        addNothing: () => "Je n'ai rien à ajouter",
        addReview: () => "Ajouter une évaluation",
        add: () => "Ajouter",
        deleteComment: () => "Voulez-vous vraiment supprimer cette évaluation ?",
        "delete": () => "Effacer",
        cancel: () => "Annuler",
        putReviewError: () => "Malheureusement, l'évaluation n'a pas pu être enregistrée. Veuillez réessayer.",
        removeReviewError: () => "Désolé, l'évaluation n'a pas pu être effacée.",
        tryAgain: () => "Réessayez",
        thankYouResponse: () => "Merci pour votre évaluation",
        numOfChar: (d) => "Il reste<b>" + d.chars + "</b> " + plural(d.chars, 0, fr, { one: "marque", other: "marques" }),
        alternativesTitle: () => "Vous pouvez ajouter une évaluation ici",
        uploadPhotoErrorCommon: () => "Malheureusement, l'ajout des photos a échoué. Veuillez réessayer.",
        uploadPhotoErrorExtension: () => "Vous avez sélectionné un type de fichier non pris en charge, ajoutez uniquement des fichiers .jpg ou .png.",
        uploadPhotoErrorSize: () => "Certaines photos sont trop petites, les dimensions minimales sont de 800x600px.",
        uploadPhotoErrorMaxCount: () => "Certaines photos n'ont pas été ajoutées, vous pouvez ajouter jusqu'à 20 photos.",
        afterDelete: () => "Nous avons supprimé votre évaluation",
        save: () => "Sauvegarder",
        editFrom: (d) => "Vous modifiez votre évaluation de " + d.date,
        imageDuplicateError: () => "Photo importée en double.",
        cancelChanges: () => "Abandonner les modifications ?",
        throwAway: () => "Abandonner",
        back: () => "Retour",
        questionsTitle: (d) => "Merci pour votre avis." + d.br + "Pouvez-vous nous aider encore avec quelques questions ?",
        questionsPosition: (d) => "Question " + d.current + "/" + d.total,
        questionsThankYou: () => "Merci pour votre contribution",
        questionsPrev: () => "Question précédente :",
        responseYes: () => "Oui",
        responseNo: () => "Non",
        responseDontKnow: () => "Je ne sais pas"
    },
    he: {},
    hr: {},
    hu: {
        commentLicence: (d) => "Értékelés hozzáadásával elfogadja a " + d.linkAgrStart + "feltételeket" + d.linkAgrEnd + " és a " + d.linkRulStart + "szabályokat" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Értékelésével egyetért a " + d.linkRulStart + "szabályokkal" + d.linkRulEnd + " és a " + d.linkPerStart + "személyes adatok kezelésére vonatkozó irányelvekkel" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "A fényképek elküldésével elfogadja a " + d.linkAgrStart + "licencfeltételeket" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Az értékelés mentésével elfogadja a " + d.linkAgrStart + "feltételeket" + d.linkAgrEnd + " és a " + d.linkRulStart + "szabályokat" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Értékeli, mint " + d.user,
        verifiedUserTitle: () => "Hitelesített felhasználó",
        verifiedUserText: () => "Ez a fiók a Seznam által hitelesített, valódi személyt, bejegyzett vállalkozást vagy szervezetet képvisel. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">További információ a hitelesített fiókokról</a>",
        tooltipMoreChoices: () => "További információ az egyes lehetőségekről",
        "continue": () => "Folytatás",
        motivateToComment: () => "Köszönjük. Csatoljon megjegyzést is, ezzel megkönnyíti mások választását.",
        textPlaceholder: () => "Itt van hely az Ön véleményének",
        textPlaceholderFirm: () => "Adjon meg szöveges értékelést is, ezzel segít másoknak a jobb tájékozódásban.",
        uploadPhoto: () => "Képfeltöltés",
        addNothing: () => "Már nem szeretnék semmit hozzáfűzni",
        addReview: () => "Értékelés hozzáadása",
        add: () => "Hozzáad",
        deleteComment: () => "Törölni szeretné az értékelést?",
        "delete": () => "Törlés",
        cancel: () => "Mégse",
        putReviewError: () => "Sajnos nem sikerült menteni az értékelést. Kérjük, próbálja újra.",
        removeReviewError: () => "Sajnos nem sikerült törölni az értékelést.",
        tryAgain: () => "Próbálja újra",
        thankYouResponse: () => "Köszönjük az értékelést",
        numOfChar: (d) => "Zbývá <b>" + d.chars + "</b> " + plural(d.chars, 0, hu, { one: "znak", other: "znaků" }),
        alternativesTitle: () => "Itt értékelheti",
        uploadPhotoErrorCommon: () => "Sajnos nem sikerült hozzáadni a fotókat. Kérjük, próbálja újra.",
        uploadPhotoErrorExtension: () => "Nem támogatott fájltípust választott. Csak .jpg vagy .png adható hozzá.",
        uploadPhotoErrorSize: () => "Néhány fotó túl kicsi, a minimális méret 800x600px.",
        uploadPhotoErrorMaxCount: () => "Néhány fotó nem került hozzáadásra, legfeljebb 20 fotót lehet feltölteni.",
        afterDelete: () => "Az értékelést töröltük",
        save: () => "Mentés",
        editFrom: (d) => "Az Ön " + d.date + "-i értékelését szerkeszti",
        imageDuplicateError: () => "A fénykép duplikáltan lett feltöltve.",
        cancelChanges: () => "El akarja vetni a változtatásokat?",
        throwAway: () => "Elvetés",
        back: () => "Vissza",
        questionsTitle: (d) => "Köszönjük az értékelést." + d.br + "Segítene nekünk még néhány kérdésben?",
        questionsPosition: (d) => "Kérdés " + d.current + " / " + d.total,
        questionsThankYou: () => "Köszönjük a segítségét",
        questionsPrev: () => "Előző kérdés:",
        responseYes: () => "Igen",
        responseNo: () => "Nem",
        responseDontKnow: () => "Nem tudom"
    },
    it: {
        commentLicence: (d) => "Aggiungendo una recensione accetti i " + d.linkAgrStart + "termini" + d.linkAgrEnd + " e le " + d.linkRulStart + "condizioni" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Inviando una valutazione, accetti le " + d.linkRulStart + "regole" + d.linkRulEnd + " e l'" + d.linkPerStart + "informativa sul trattamento dei dati personali" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Inviando le foto accetti le " + d.linkAgrStart + "condizioni di licenza" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Salvando la valutazione accetti le " + d.linkAgrStart + "condizioni" + d.linkAgrEnd + " e le " + d.linkRulStart + "regole" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Stai valutando come " + d.user,
        verifiedUserTitle: () => "Profilo verificato",
        verifiedUserText: () => "Questo profilo è verificato da Seznam e rappresenta una persona reale, una compagnia o un ente. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Maggiori informazioni sugli account verificati</a>",
        tooltipMoreChoices: () => "Maggiori informazioni sulle diverse opzioni",
        "continue": () => "Continua",
        motivateToComment: () => "Grazie! Lascia un commento per aiutare gli altri utenti.",
        textPlaceholder: () => "Condividi la tua opinione qui",
        textPlaceholderFirm: () => "Aggiungi anche una recensione testuale e aiuterai gli altri a orientarsi meglio.",
        uploadPhoto: () => "Aggiungi foto",
        addNothing: () => "Non ho altro da aggiungere",
        addReview: () => "Aggiungi una valutazione",
        add: () => "Aggiungi",
        deleteComment: () => "Eliminare questa recensione?",
        "delete": () => "Elimina",
        cancel: () => "Annulla",
        putReviewError: () => "Impossibile salvare la recensione. Riprova più tardi.",
        removeReviewError: () => "Purtroppo la recensione non può essere eliminata.",
        tryAgain: () => "Riprova",
        thankYouResponse: () => "Grazie per la recensione",
        numOfChar: (d) => "<b>" + d.chars + "</b> " + plural(d.chars, 0, it, { one: "carattere rimanente", other: "caratteri rimanenti" }),
        alternativesTitle: () => "Recensisci i luoghi in questa posizione",
        uploadPhotoErrorCommon: () => "Spiacenti, non è stato possibile aggiungere le foto. Riprova.",
        uploadPhotoErrorExtension: () => "Hai selezionato un tipo di file non supportato, aggiungi solo .jpg, .png o .heic.",
        uploadPhotoErrorSize: () => "Alcune foto sono troppo piccole, le dimensioni minime sono 800x600px.",
        uploadPhotoErrorMaxCount: () => "Alcune foto non sono state aggiunte, è possibile aggiungerne solo 20.",
        afterDelete: () => "Recensione eliminata correttamente",
        save: () => "Salva",
        editFrom: (d) => "Stai aggiornando la tua recensione del giorno " + d.date,
        imageDuplicateError: () => "Duplica foto.",
        cancelChanges: () => "Annullare le modifiche?",
        throwAway: () => "Scarta",
        back: () => "Indietro",
        questionsTitle: (d) => "Grazie per la valutazione." + d.br + "Ci aiuti ancora con qualche domanda?",
        questionsPosition: (d) => "Domanda " + d.current + " di " + d.total,
        questionsThankYou: () => "Grazie per il tuo aiuto",
        questionsPrev: () => "Domanda precedente:",
        responseYes: () => "Sì",
        responseNo: () => "No",
        responseDontKnow: () => "Non lo so"
    },
    nl: {
        numOfChar: (d) => "Zbývá <b>" + d.chars + "</b> " + plural(d.chars, 0, nl, { one: "znak", other: "znaků" })
    },
    no: {},
    pl: {
        commentLicence: (d) => "Dodając ocenę, akceptujesz " + d.linkAgrStart + "warunki" + d.linkAgrEnd + " i " + d.linkRulStart + "zasady" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Ocena oznacza, że zgadzasz się z " + d.linkRulStart + "zasadami" + d.linkRulEnd + " oraz " + d.linkPerStart + "polityką prywatności" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Przesyłając zdjęcia, zgadzasz się na " + d.linkAgrStart + "warunki licencyjne." + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Zapisując ocenę wyrażasz zgodę na " + d.linkAgrStart + "warunki" + d.linkAgrEnd + " i " + d.linkRulStart + "zasady" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Oceniasz jako " + d.user,
        verifiedUserTitle: () => "Zweryfikowany użytkownik",
        verifiedUserText: () => "To konto jest zweryfikowane przez Seznam i reprezentuje prawdziwą osobę, zarejestrowaną firmę lub podmiot. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Więcej o zweryfikowanych kontach</a>",
        tooltipMoreChoices: () => "Więcej o poszczególnych opcjach",
        "continue": () => "Kontynuuj",
        motivateToComment: () => "Dziękujemy. Dodaj komentarz, aby ułatwić innym wybór.",
        textPlaceholder: () => "Miejsce na Twoją opinię",
        textPlaceholderFirm: () => "Dodaj również tekst, aby pomóc innym.",
        uploadPhoto: () => "Dodaj zdjęcie",
        addNothing: () => "Nie chcę już niczego dodawać",
        addReview: () => "Dodaj ocenę",
        add: () => "Dodaj",
        deleteComment: () => "Czy chcesz usunąć ocenę?",
        "delete": () => "Usuń",
        cancel: () => "Anuluj",
        putReviewError: () => "Nie udało się zapisać Twojej opinii. Spróbuj ponownie.",
        removeReviewError: () => "Niestety nie można było usunąć oceny.",
        tryAgain: () => "Próbuj ponownie",
        thankYouResponse: () => "Dziękujemy za przesłanie oceny",
        numOfChar: (d) => "Pozostało: <b>" + d.chars + "</b> " + plural(d.chars, 0, pl, { one: "znak", few: "znaki", many: "znaków", other: "znaku" }),
        alternativesTitle: () => "Oceń miejsca w tej lokalizacji",
        uploadPhotoErrorCommon: () => "Nie udało się dodać zdjęć. Spróbuj ponownie.",
        uploadPhotoErrorExtension: () => "Wybrano nieobsługiwany typ pliku, można dodawać tylko pliki .jpg, .png lub .heic.",
        uploadPhotoErrorSize: () => "Niektóre zdjęcia są za małe, minimalne wymiary to 800x600 px.",
        uploadPhotoErrorMaxCount: () => "Niektóre zdjęcia nie zostały dodane, można dodać tylko 20 zdjęć.",
        afterDelete: () => "Ocena została usunięta",
        save: () => "Zapisz",
        editFrom: (d) => "Edytujesz swoją ocenę z " + d.date,
        imageDuplicateError: () => "Przesłano duplikat zdjęcia.",
        cancelChanges: () => "Odrzucić zmiany?",
        throwAway: () => "Zrezygnuj",
        back: () => "Wstecz",
        questionsTitle: (d) => "Dziękujemy za ocenę." + d.br + "Czy możesz odpowiedzieć jeszcze na kilka pytań?",
        questionsPosition: (d) => "Pytanie " + d.current + "/" + d.total,
        questionsThankYou: () => "Dziękujemy za pomoc",
        questionsPrev: () => "Poprzednie pytanie:",
        responseYes: () => "Tak",
        responseNo: () => "Nie",
        responseDontKnow: () => "Nie wiem"
    },
    pt: {},
    ro: {},
    ru: {
        commentLicence: (d) => "Добавляя отзыв, вы соглашаетесь с " + d.linkAgrStart + "условиями" + d.linkAgrEnd + " и " + d.linkRulStart + "правилами" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Оценивая, вы соглашаетесь с " + d.linkRulStart + "правилами" + d.linkRulEnd + " и " + d.linkPerStart + "политикой обработки персональных данных" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Отправляя фотографии, вы соглашаетесь с " + d.linkAgrStart + "условиями лицензии" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Сохраняя оценку, вы соглашаетесь с " + d.linkAgrStart + "условиями" + d.linkAgrEnd + " и " + d.linkRulStart + "правилами" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Вы оставляете отзыв как " + d.user,
        verifiedUserTitle: () => "Подтвержденный пользователь",
        verifiedUserText: () => "Этот аккаунт проверен Seznam и представляет реальное лицо, зарегистрированную компанию или субъект. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Больше о подтвержденных аккаунтах</a>",
        tooltipMoreChoices: () => "Подробнее об отдельных опциях",
        "continue": () => "Продолжить",
        motivateToComment: () => "Спасибо. Добавьте комментарий, чтобы помочь с выбором остальным.",
        textPlaceholder: () => "Здесь вы можете оставить свой отзыв",
        textPlaceholderFirm: () => "Добавьте подробный отзыв, чтобы помочь другим лучше разобраться.",
        uploadPhoto: () => "Добавить фото",
        addNothing: () => "Мне нечего добавить",
        addReview: () => "Добавить отзыв",
        add: () => "Добавить",
        deleteComment: () => "Хотите удалить отзыв?",
        "delete": () => "Удалить",
        cancel: () => "Отменить",
        putReviewError: () => "К сожалению, не удалось сохранить отзыв. Пожалуйста, повторите попытку позже.",
        removeReviewError: () => "К сожалению, не удалось удалить отзыв.",
        tryAgain: () => "Повторить",
        thankYouResponse: () => "Спасибо за ваш отзыв",
        numOfChar: (d) => "Осталось <b>" + d.chars + "</b> " + plural(d.chars, 0, ru, { one: "знак", few: "знака", other: "знаков" }),
        alternativesTitle: () => "Сюда вы можете добавить отзыв",
        uploadPhotoErrorCommon: () => "Не удалось добавить фото. Пожалуйста, повторите попытку позже.",
        uploadPhotoErrorExtension: () => "Вы выбрали неподдерживаемый тип файла, добавьте только .jpg или .png.",
        uploadPhotoErrorSize: () => "Некоторые фото слишком маленькие, минимальный размер 800x600px.",
        uploadPhotoErrorMaxCount: () => "Некоторые фото не были добавлены, можно добавить только 20 фото.",
        afterDelete: () => "Отзыв удален",
        save: () => "Сохранить",
        editFrom: (d) => "Вы редактируете свой отзыв от " + d.date,
        imageDuplicateError: () => "Загружен дубликат фотографии.",
        cancelChanges: () => "Хотите отклонить изменения?",
        throwAway: () => "Отклонить",
        back: () => "Назад",
        questionsTitle: (d) => "Спасибо за оценку." + d.br + "Поможете ли нам еще с несколькими вопросами?",
        questionsPosition: (d) => "Вопрос " + d.current + " / " + d.total,
        questionsThankYou: () => "Спасибо за вашу помощь",
        questionsPrev: () => "Предыдущий вопрос:",
        responseYes: () => "Да",
        responseNo: () => "Нет",
        responseDontKnow: () => "Не знаю"
    },
    sk: {
        commentLicence: (d) => "Pridaním komentára súhlasíte s " + d.linkAgrStart + "podmienkami" + d.linkAgrEnd + " a " + d.linkRulStart + "pravidlami" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Hodnotením súhlasíte s " + d.linkRulStart + "pravidlami" + d.linkRulEnd + " a " + d.linkPerStart + "zásadami spracovania osobných údajov" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Odoslaním fotiek súhlasíte s " + d.linkAgrStart + "licenčnými podmienkami" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Uložením hodnotenia súhlasíte s " + d.linkAgrStart + "podmienkami" + d.linkAgrEnd + " a " + d.linkRulStart + "pravidlami" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Hodnotíte ako " + d.user,
        verifiedUserTitle: () => "Overený používateľ",
        verifiedUserText: () => "Tento účet je overený Seznamom a predstavuje skutočnú osobu, zaregistrovanú firmu alebo subjekt. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Viac o overených účtoch</a>",
        tooltipMoreChoices: () => "Viac o jednotlivých možnostiach",
        "continue": () => "Pokračovať",
        motivateToComment: () => "Ďakujeme. Pripojte komentár, uľahčíte výber ostatným.",
        textPlaceholder: () => "Tu je miesto pre váš názor",
        textPlaceholderFirm: () => "Vložte ešte textové hodnotenie a pomôžete sa lepšie zorientovať ostatným.",
        uploadPhoto: () => "Pridať fotku",
        addNothing: () => "Už nechcem nič dodať",
        addReview: () => "Pridať hodnotenie",
        add: () => "Pridať",
        deleteComment: () => "Chcete hodnotenie vymazať?",
        "delete": () => "Odstrániť",
        cancel: () => "Zrušiť",
        putReviewError: () => "Hodnotenie sa žiaľ nepodarilo uložiť. Skúste to znova.",
        removeReviewError: () => "Hodnotenie sa žiaľ nepodarilo odstrániť.",
        tryAgain: () => "Skúsiť znova",
        thankYouResponse: () => "Ďakujeme za hodnotenie",
        numOfChar: (d) => "Máte ešte <b>" + d.chars + "</b> " + plural(d.chars, 0, sk, { one: "znak", few: "znaky", other: "znakov" }),
        alternativesTitle: () => "Na tomto mieste môžete ohodnotiť",
        uploadPhotoErrorCommon: () => "Fotky sa žiaľ nepodarilo pridať. Skúste to znova.",
        uploadPhotoErrorExtension: () => "Vybrali ste nepodporovaný typ súboru, pridajte len .jpg, .png alebo .heic.",
        uploadPhotoErrorSize: () => "Niektoré fotky sú príliš malé, minimálne rozmery sú 800x600px.",
        uploadPhotoErrorMaxCount: () => "Niektoré fotky sa nepridali, je možné pridať iba 20 fotiek.",
        afterDelete: () => "Hodnotenie sme vymazali",
        save: () => "Uložiť",
        editFrom: (d) => "Upravujete svoje hodnotenie z " + d.date,
        imageDuplicateError: () => "Fotka nahraná duplicitne.",
        cancelChanges: () => "Chcete zmeny zahodiť?",
        throwAway: () => "Zahodiť",
        back: () => "Späť",
        questionsTitle: (d) => "Ďakujeme za hodnotenie." + d.br + "Pomôžete nám ešte s niekoľkými otázkami?",
        questionsPosition: (d) => "Otázka " + d.current + "/" + d.total,
        questionsThankYou: () => "Ďakujeme za vašu pomoc",
        questionsPrev: () => "Predchádzajúca otázka:",
        responseYes: () => "Áno",
        responseNo: () => "Nie",
        responseDontKnow: () => "Neviem"
    },
    sl: {
        commentLicence: (d) => "Z dodajanjem ocene se strinjate z " + d.linkAgrStart + "pogoji" + d.linkAgrEnd + " in " + d.linkRulStart + "pravili" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Z ocenjevanjem se strinjate z " + d.linkRulStart + "pravili" + d.linkRulEnd + " in " + d.linkPerStart + "pravili o obdelavi osebnih podatkov" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Z oddajo fotografij se strinjate z " + d.linkAgrStart + "licenčnimi pogoji" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Z shranjevanjem ocene se strinjate z " + d.linkAgrStart + "pogoji" + d.linkAgrEnd + " in " + d.linkRulStart + "pravili" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Ocenjujete kot " + d.user,
        verifiedUserTitle: () => "Preverjen uporabnik",
        verifiedUserText: () => "Ta račun je preverjen s strani Seznama in predstavlja pravo osebo, registrirano podjetje ali subjekt. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Več o preverjenih računih</a>",
        tooltipMoreChoices: () => "Več o posameznih možnostih",
        "continue": () => "Nadaljuj",
        motivateToComment: () => "Hvala. Dodajte komentar, olajšali boste izbiro drugim.",
        textPlaceholder: () => "Tu je prostor za vaše mnenje",
        textPlaceholderFirm: () => "Dodajte še besedilno oceno in drugim boste pomagali pri boljši orientaciji.",
        uploadPhoto: () => "Dodaj fotografijo",
        addNothing: () => "Ne želim ničesar dodati",
        addReview: () => "Dodaj oceno",
        add: () => "Dodaj",
        deleteComment: () => "Želite izbrisati oceno?",
        "delete": () => "Izbriši",
        cancel: () => "Prekliči",
        putReviewError: () => "Ocene žal ni bilo mogoče shraniti. Prosimo, poskusite znova.",
        removeReviewError: () => "Ocene žal ni bilo mogoče izbrisati.",
        tryAgain: () => "Poskusi znova",
        thankYouResponse: () => "Hvala za oceno",
        numOfChar: (d) => "Ostaja še <b>" + d.chars + "</b> " + plural(d.chars, 0, sl, { one: "znak", two: "znaka", few: "znaki", other: "znakov" }),
        alternativesTitle: () => "Na tem mestu lahko ocenite",
        uploadPhotoErrorCommon: () => "Fotografij žal ni bilo mogoče dodati. Prosimo, poskusite znova.",
        uploadPhotoErrorExtension: () => "Izbrali ste nepodprto vrsto datoteke, dodajte samo .jpg ali .png.",
        uploadPhotoErrorSize: () => "Nekatere fotografije so premajhne, najmanjša velikost je 800x600 px.",
        uploadPhotoErrorMaxCount: () => "Nekatere fotografije niso bile dodane, možno je dodati največ 20 fotografij.",
        afterDelete: () => "Ocena je bila izbrisana",
        save: () => "Shrani",
        editFrom: (d) => "Urejate svojo oceno z dne " + d.date,
        imageDuplicateError: () => "Fotografija je bila naložena podvojeno.",
        cancelChanges: () => "Želite zavreči spremembe?",
        throwAway: () => "Zavrzi",
        back: () => "Nazaj",
        questionsTitle: (d) => "Hvala za oceno." + d.br + "Ali nam lahko odgovorite še na nekaj vprašanj?",
        questionsPosition: (d) => "Vprašanje " + d.current + " / " + d.total,
        questionsThankYou: () => "Hvala za vašo pomoč",
        questionsPrev: () => "Prejšnje vprašanje:",
        responseYes: () => "Da",
        responseNo: () => "Ne",
        responseDontKnow: () => "Ne vem"
    },
    sr: {},
    sv: {},
    tr: {
        numOfChar: (d) => "Zbývá <b>" + d.chars + "</b> " + plural(d.chars, 0, tr, { one: "znak", other: "znaků" })
    },
    uk: {
        commentLicence: (d) => "Додаючи відгук, ви погоджуєтесь з " + d.linkAgrStart + "умовами" + d.linkAgrEnd + " та " + d.linkRulStart + "правилами" + d.linkRulEnd + ".",
        commentLicenceFirm: (d) => "Оцінюючи, ви погоджуєтеся з " + d.linkRulStart + "правилами" + d.linkRulEnd + " та " + d.linkPerStart + "принципами обробки персональних даних" + d.linkPerEnd + ".",
        picturesLinkFirm: (d) => "Надсилаючи фотографії, ви погоджуєтеся з " + d.linkAgrStart + "ліцензійними умовами" + d.linkAgrEnd + ".",
        acceptLicence: (d) => "Зберігаючи свій відгук, ви погоджуєтесь з " + d.linkAgrStart + "умовами" + d.linkAgrEnd + " та " + d.linkRulStart + "правилами" + d.linkRulEnd + ".",
        reviewAsUser: (d) => "Ви залишаєте відгук як " + d.user,
        verifiedUserTitle: () => "Підтверджений користувач",
        verifiedUserText: () => "Цей обліковий запис підтверджено в Seznam і належить реальній особі, зареєстрованій компанії або організації. <a href=\"https://napoveda.seznam.cz/cz/seznam-bankovni-identita/\" target=\"_blank\" rel=\"noopener\">Більше про підтверджені облікові записи</a>",
        tooltipMoreChoices: () => "Більше про окремі опції",
        "continue": () => "Продовжити",
        motivateToComment: () => "Дякуємо. Додайте коментар, щоб полегшити вибір іншим користувачам.",
        textPlaceholder: () => "Поділіться своєю думкою",
        textPlaceholderFirm: () => "Крім того, додавши відгук, ви можете допомогти іншим краще зорієнтуватися.",
        uploadPhoto: () => "Додати фотографію",
        addNothing: () => "Мені більше нічого додати",
        addReview: () => "Додати відгук",
        add: () => "Додати",
        deleteComment: () => "Бажаєте видалити відгук?",
        "delete": () => "Видалити",
        cancel: () => "Скасувати",
        putReviewError: () => "На жаль, не вдалося зберегти ваш відгук. Будь ласка, спробуйте пізніше.",
        removeReviewError: () => "На жаль, не вдалося видалити відгук.",
        tryAgain: () => "Спробувати ще раз",
        thankYouResponse: () => "Дякуємо за ваш відгук",
        numOfChar: (d) => "Залишилося <b>" + d.chars + "</b> " + plural(d.chars, 0, uk, { one: "знак", few: "знаків", other: "знаки" }),
        alternativesTitle: () => "Залиште відгук на це місце",
        uploadPhotoErrorCommon: () => "Не вдалося опублікувати фотографії. Будь ласка, спробуйте пізніше.",
        uploadPhotoErrorExtension: () => "Ви вибрали непідтримуваний тип файлу, додайте .jpg або .png.",
        uploadPhotoErrorSize: () => "Деякі фотографії замалі, мінімальний розмір 800x600 пікселів.",
        uploadPhotoErrorMaxCount: () => "Деякі фотографії не додано, можна додати лише 20 фотографій.",
        afterDelete: () => "Відгук видалено",
        save: () => "Зберегти",
        editFrom: (d) => "Ви змінюєте свій відгук від " + d.date,
        imageDuplicateError: () => "Подвійне завантаження фото.",
        cancelChanges: () => "Бажаєте відхилити зміни?",
        throwAway: () => "Відхилити",
        back: () => "Назад",
        questionsTitle: (d) => "Дякуємо за відгук." + d.br + "Чи можете ви відповісти ще на кілька запитань?",
        questionsPosition: (d) => "Питання " + d.current + " з " + d.total,
        questionsThankYou: () => "Дякуємо за вашу допомогу",
        questionsPrev: () => "Попереднє запитання:",
        responseYes: () => "Так",
        responseNo: () => "Ні",
        responseDontKnow: () => "Не знаю"
    },
    vi: {}
};

const POIAGG_URL = "/poiagg";
const POITYPES = {};
// detail options
function getDetail({ endpoint, source, id, lang = DEFAULT_LANG, apiKey = "", options, }) {
    if (source === "coor" && typeof id === "string") {
        const coords = id.split(",");
        const [lon, lat] = coords;
        // @ts-ignore
        return Promise.resolve({
            status: 200,
            statusMessage: "Ok",
            error: "",
            noError: true,
            data: {
                poi: getCoordPoi({ lon: parseFloat(lon), lat: parseFloat(lat) }),
            },
        });
    }
    return frpc(Object.assign({ url: `${endpoint}${POIAGG_URL}`, method: "detail", args: [source, id, Object.assign({ lang: getPoiaggRequestLangs(lang) }, options)] }, apiKey ? { headers: [
            { name: "X-Mapy-Api-Key", value: apiKey },
        ] } : {}));
}
async function getDescriptions({ endpoint, pois, lang = DEFAULT_LANG, apiKey = "", options, }) {
    const output = {
        data: { poi: [] },
        error: "",
        noError: true,
        status: 200,
    };
    if (pois.length === 0) {
        return output;
    }
    const descriptionData = await frpc(Object.assign({ url: `${endpoint}${POIAGG_URL}`, method: "description", args: [poisToDescriptionOptions(pois), Object.assign({ lang: getPoiaggRequestLangs(lang) }, options)] }, apiKey ? { headers: [
            { name: "X-Mapy-Api-Key", value: apiKey },
        ] } : {}));
    output.error = descriptionData.error;
    output.noError = descriptionData.noError;
    output.status = descriptionData.status;
    if (descriptionData.noError) {
        const descPois = [];
        pois.forEach(poi => {
            const filtered = descriptionData.data.poi.filter(filteredPoi => filteredPoi.source === poi.source && filteredPoi.id === poi.id);
            descPois.push(filtered[0]);
        });
        output.data.poi = descPois;
    }
    return output;
}
async function initPOIIcons({ endpoint, apiKey = "", }) {
    const iconsData = await frpc(Object.assign({ url: `${endpoint}${POIAGG_URL}`, method: "poiicons", args: [] }, apiKey ? { headers: [
            { name: "X-Mapy-Api-Key", value: apiKey },
        ] } : {}));
    if (iconsData.noError) {
        iconsData.data.poitype.forEach(poiType => {
            const icon = iconsData.data.poiicon.find(poiIcon => poiIcon.id === poiType.icon_id);
            if (icon) {
                POITYPES[poiType.id] = icon;
            }
        });
    }
}
function getIcon(typeId, scale = 1) {
    const tld = getTLD();
    const iconId = typeId in POITYPES
        ? POITYPES[typeId].id
        : DEFAULT_TYPE_ID;
    return `https://api.mapy.${tld}/poiimg/icon/${iconId}?scale=${scale}`;
}

/* eslint-disable camelcase */
function getLocaleData(locales, lang) {
    if (!(lang in locales)) {
        if ([DEFAULT_LANG, "sk"].indexOf(lang) !== -1) {
            return locales[DEFAULT_LANG];
        }
        else if ("en" in locales) {
            return locales["en"];
        }
    }
    return locales[lang];
}
function isLocalhost() {
    return location.hostname.indexOf("localhost") !== -1;
}
function getLocale(element = document.body) {
    const closestElement = element.closest("[lang]");
    // pro testovani na localhostu nechceme jazyk browseru
    return closestElement ? closestElement.lang : !isLocalhost() && navigator.languages.length ? navigator.languages[0].split("-")[0] : DEFAULT_LANG;
}
function translate(locales, lang, method, data = {}) {
    const localeData = getLocaleData(locales, lang);
    if (method in localeData) {
        return localeData[method](data);
    }
    return method;
}
function transDialog(lang, method, data = {}) {
    return translate(DialogLocales, lang, method, data);
}
function getTLD() {
    if (location.origin.indexOf("dev.dszn.cz") !== -1) {
        return "dev.dszn.cz";
    }
    else if (location.origin.indexOf("test.dszn.cz") !== -1) {
        return "test.dszn.cz";
    }
    return "cz";
}
function isFirm(poiSource) {
    return poiSource === FIRM_SOURCE;
}
/**
 * Combines strings and/or objects into one single string usable as a value for the className property
 */
const classNames = (classes = []) => (Array.isArray(classes)
    ? classes
    : [classes]).reduce((cls, cl) => {
    // an empty string will still pass - it is faster and breaks nothing
    if (typeof cl === "string") {
        cl && cls.push(cl);
    }
    else {
        // every truthy property is included in the final className
        cl && Object.keys(cl).forEach(key => cl[key] && cls.push(key));
    }
    return cls;
}, []).filter(item => item).join(" ");
// 0..5 -> 0..100
function starsToRating(stars) {
    return stars / STARS_COUNT * 100 >>> 0;
}
function ratingToStars(rating) {
    return rating / 100 * STARS_COUNT;
}
function getRandomId(name = "paint0_linear") {
    const randomId = Math.random().toString(16).replace("0.", "");
    return `${name}_${randomId}`;
}
function imgToDataSrc({ image = null, canvasPreviewSize = 100, }) {
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    let canWidth = 0;
    let canHeight = 0;
    if (width > height) {
        canHeight = canvasPreviewSize;
        canWidth = Math.floor(width / height * canvasPreviewSize);
    }
    else {
        canWidth = canvasPreviewSize;
        canHeight = Math.floor(height / width * canvasPreviewSize);
    }
    // vytvorime canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canWidth;
    canvas.height = canHeight;
    ctx.drawImage(image, 0, 0, width, height, 0, 0, canWidth, canHeight);
    return canvas.toDataURL();
}
function srcToImage(src) {
    return new Promise(resolve => {
        const output = {
            image: null,
            hasError: false,
        };
        const image = new Image();
        image.addEventListener("load", () => {
            output.image = image;
            resolve(output);
        });
        image.addEventListener("error", () => {
            output.hasError = true;
            resolve(output);
        });
        image.src = src;
    });
}
async function fileToSrc({ file, minWidth = 800, minHeight = 600, canvasPreviewSize = 100, mimeTypes = [], }) {
    const output = {
        hasError: false,
        src: "",
        error: "none",
        width: 0,
        height: 0,
    };
    if (mimeTypes.length > 0 && !mimeTypes.includes(file.type)) {
        output.error = "file-type";
    }
    else {
        // url obrazku
        try {
            const revokeUrl = URL.createObjectURL(file);
            // obrazek
            const imageData = await srcToImage(revokeUrl);
            URL.revokeObjectURL(revokeUrl);
            if (imageData.hasError) {
                output.error = "img-load";
            }
            else {
                const coverImage = imageData.image;
                const width = coverImage.naturalWidth;
                const height = coverImage.naturalHeight;
                output.width = coverImage.naturalWidth;
                output.height = coverImage.naturalHeight;
                if (width < minWidth || height < minHeight) {
                    // nastavime chybu
                    output.error = "dimension";
                }
                else {
                    const src = imgToDataSrc({
                        image: coverImage,
                        canvasPreviewSize,
                    });
                    output.src = src;
                }
            }
        }
        catch (exc) {
            /* eslint-disable-next-line */
            console.log(exc);
            output.error = "img-load";
        }
    }
    output.hasError = output.error !== "none";
    return output;
}
async function frpc({ url = "", method = "", args = [], hints = {}, headers = [], }) {
    const output = {
        data: null,
        noError: true,
        error: "",
        status: 500,
    };
    try {
        const requestData = await call(method, args, { url, withCredentials: true, hints, headers });
        const noError = requestData.status === STATUS_OK;
        output.status = requestData.status;
        output.data = noError
            ? requestData
            : null;
        output.error = noError
            ? ""
            : `Wrong status code ${requestData.status}`;
        output.noError = noError;
    }
    catch (exc) {
        output.error = exc.message || "";
        output.noError = false;
    }
    return output;
}
function getPoiaggRequestLangs(lang) {
    if (lang === DEFAULT_LANG) {
        return [lang];
    }
    return [lang, DEFAULT_LANG];
}
function getAlternatives(poi) {
    var _a, _b;
    return ((_b = (_a = poi.extend) === null || _a === void 0 ? void 0 : _a.poi) === null || _b === void 0 ? void 0 : _b.alternatives) || [];
}
function poisToDescriptionOptions(pois) {
    const options = {};
    pois.forEach(poi => {
        if (!(poi.source in options)) {
            options[poi.source] = [];
        }
        options[poi.source].push(poi.id);
    });
    // eslint-disable-next-line guard-for-in
    for (const source in options) {
        options[source] = [...Array.from(new Set(options[source]))];
    }
    return options;
}
function getCoordPoi(mark) {
    const { lon, lat } = mark;
    return {
        source: "coor",
        id: `${lon.toString()},${lat.toString()}`,
        title: `${lon},${lat}`,
        mark: { lat, lon },
        typeId: DEFAULT_TYPE_ID,
        titleVars: {
            locationMain1: "",
            locationMain2: [],
            locationMain3: [],
            locationSub1: "",
            locationSub2: [],
            locationSub3: [],
            specification: "",
            titleMain: "",
            titleMapMain: "",
            titleMapSub: "",
            titleSmartMain: "",
            titleSmartSub: "",
            titleSub: "",
        },
    };
}
function poiToAlternativeItem(poi) {
    var _a;
    const icon = getIcon(poi.typeId);
    const icon2x = getIcon(poi.typeId, 2);
    return {
        icon,
        title: poi.title || "",
        subTitle: ((_a = poi.titleVars) === null || _a === void 0 ? void 0 : _a.specification) || "",
        iconScrSet: `${icon} 1x, ${icon2x} 2x`,
        data: poi,
    };
}
function getStructuredReviewData(items) {
    return items.map(item => ({
        key: item.key,
        value: item.rating,
    }));
}
function roundTo(value, roundDec) {
    const floorVal = Math.floor(value / roundDec);
    const ceilVal = Math.ceil(value / roundDec);
    if (Math.abs((floorVal * roundDec) - value) < Math.abs((ceilVal * roundDec) - value)) {
        return floorVal * roundDec;
    }
    return ceilVal * roundDec;
}
/*
 * PA - pocet atributu
 * SH - přednastavené střední hodnoty/mediánu hodnocení SH (viz administrace)
 * SN - pocet nastavenych smajliku
 * PN - pocet nastavenych zamracku
 *
 * pocet hvezd = SH + PN*((5-SH)/PA) - SN*((SH-1)/PA) zaokrouhleno na 0.5
 */
function calcStars(PA, SH, SN, PN) {
    return SH + (SN * ((5 - SH) / PA)) - (PN * ((SH - 1) / PA));
}
function getStarsFromStructuredItems(SH, items) {
    const PA = items.length;
    const SN = items.filter(item => item.value === EMOJI_POS_VALUE).length;
    const PN = items.filter(item => item.value === EMOJI_NEG_VALUE).length;
    const stars = calcStars(PA, SH, SN, PN);
    return roundTo(stars, 0.5);
}
function restoreUploadedPhotos(photos) {
    return photos.map(photo => ({
        id: photo.mediaId.toString(),
        name: photo.mediaId.toString(),
        mediaId: photo.mediaId,
        percent: 100,
        src: photo.src,
        status: photo.status,
    }));
}
function getLink(type, lang, isSourceFirm) {
    if (type === "rules") {
        const source = isSourceFirm
            ? RULES_LINKS_FIRM
            : RULES_LINKS_NOFIRM;
        return Object.keys(source).indexOf(lang) > -1 ? source[lang] : source.en;
    }
    return `https://licence.mapy.${getTLD()}/?doc=mapy_lu&lang=${lang}`;
}
function getPutReviewSource(service) {
    switch (service) {
        case "firmy":
            return "firmy";
        case "fulltext":
            return "fulltext";
        case "sluzby":
            return "sluzby";
    }
    // def.
    return "mapy-web";
}
function getTheme(service) {
    if (service === "firmy" || service === "sluzby") {
        return "firmy";
    }
    return "mapy";
}
function transformMyReview(data) {
    const output = {
        reviewId: 0,
        rating: 0,
        text: "",
        media_ids: [],
        structured_rating: [],
        photos: [],
    };
    if (data) {
        const gallery = data.gallery || [];
        output.reviewId = data.id;
        output.text = data.text;
        output.rating = ratingToStars(data.rating);
        output.structured_rating = (data.structured_rating || []).map(item => ({
            key: item.key,
            value: item.rating,
        }));
        output.media_ids = gallery.map(item => item.id);
        output.photos = gallery.map(item => ({
            mediaId: item.id,
            src: item.urls.default.replace("{width}", "80").replace("{height}", "80"),
            status: item.status,
        }));
    }
    return output;
}
function debounce(func, wait) {
    let timeout = 0;
    return function debounced(...params) {
        function later() {
            timeout = 0;
            func(...params);
        }
        clearTimeout(timeout);
        timeout = window.setTimeout(later, wait);
    };
}
function escapeHTML(input) {
    return input.replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export { poiToAlternativeItem as A, classNames as B, isFirm as C, getAlternatives as D, getLink as E, debounce as F, getStructuredReviewData as G, getStarsFromStructuredItems as H, fileToSrc as I, restoreUploadedPhotos as J, getRandomId as K, escapeHTML as L, de as a, es as b, cs as c, da as d, en as e, fr as f, getLocale as g, hu as h, it as i, pl as j, sl as k, translate as l, getTheme as m, nl as n, transDialog as o, plural as p, transformMyReview as q, ru as r, sk as s, tr as t, uk as u, getPutReviewSource as v, starsToRating as w, getDetail as x, getDescriptions as y, initPOIIcons as z };

//# sourceMappingURL=utils2.js.map